"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.INNER_BAR = exports.CONTAINER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    CONTAINER = (0, _cxs["default"])({
  background: _vars.COLOURS.mono.offwhite35,
  height: "8px",
  width: "100%",
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 3
});

exports.CONTAINER = CONTAINER;

var INNER_BAR = function INNER_BAR(a) {
  return (0, _cxs["default"])({
    background: _vars.COLOURS.cyan.jungleGreen.monkey,
    height: "100%",
    transition: "width .5s",
    width: "".concat(a, "%")
  });
};

exports.INNER_BAR = INNER_BAR;